<template>
  <v-dialog v-model="dialog" width="1000px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title class="text-uppercase">
          Tìm kiếm và chọn giáo viên
        </v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="close">close</v-icon>
      </v-card-title>
      <v-card md="12" outlined class="ma-4 elevation-0">
        <TeacherFilter @on-excel-import="() => (isExcelImport = true)" />
      </v-card>
      <v-card md="12" outlined class="mx-4 mb-6 elevation-0">
        <ListStudentsSMS v-if="!isExcelImport" />
        <ListStudentsIndependent v-else />
      </v-card>
      <hr color="#E0E0E0" />
      <v-card-actions>
        <v-btn class="ma-2" outlined light @click="close" width="100px">Hủy</v-btn>
        <v-spacer />
        <div class="pr-4 grey--text">Đã chọn {{ selectedTeachers.length }} giáo viên</div>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="close" width="100px">
          Chọn
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import ListStudentsSMS from '@/modules/post/selectStudentDialog/ListStudentSMS.vue'
import ListStudentsIndependent from '@/modules/post/selectStudentDialog/ListStudentsIndependent.vue'
import TeacherFilter from './TeacherFilter.vue'

export default {
  components: {
    TeacherFilter,
    ListStudentsSMS,
    ListStudentsIndependent
  },
  data: () => ({ dialog: false, isExcelImport: false }),
  computed: {
    ...mapState('PostCreateAuto', ['selectedTeachers'])
  },
  methods: {
    open() {
      this.dialog = true
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    close() {
      this.dialog = false
      this.reset()
    }
  }
}
</script>
